module.exports = __webpack_public_path__ + "img/pt-single-3.bd0f99ac.jpg";